import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "account-info__items account-info__items" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "enterprise-real-form-upload" }, " 请上传证件的彩色扫描件或照片，并确保您上传的图片信息内容清晰、可辨，单个文件大小不超过 5M； ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "enterprise-real-form-upload" }, " 请上传证件的彩色扫描件或照片，并确保您上传的图片信息内容清晰、可辨，单个文件大小不超过5M ", -1)

import {
  BaseFormItem,
  BaseInput,
  BaseUpload,
  BaseTextContent,
  BaseTextTitle
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import infoStore from '../../store/info';
import { uploadApi } from '@/common/data-source/common/apis';
import { useUpload } from '../../hooks';
import { validator } from '@/utils';
import BizFormTimes from '@/components/biz/biz-form-times';


export default /*#__PURE__*/_defineComponent({
  __name: 'account-info-handled',
  setup(__props) {

const { formData, formRef, disabled } = storeToRefs(infoStore());

const { uploadModelMap, onUploadErr, onUploadRemove, onUploadChange } =
  useUpload(formData, formRef, ['transactorCardZheng', 'transactorCardFan']);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTextTitle), { class: "account-info__items__title" }, {
      default: _withCtx(() => [
        _createTextVNode("经办人信息")
      ]),
      _: 1
    }),
    _createVNode(_unref(BaseTextContent), { class: "account-info__content" }, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseFormItem), {
          label: "姓名",
          prop: "transactorName",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              style: {"width":"100%"},
              type: "text",
              placeholder: "请输入",
              modelValue: _unref(formData).transactorName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).transactorName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "身份证号",
          prop: "transactorCardCode",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              style: {"width":"100%"},
              type: "text",
              placeholder: "请输入",
              inputTextReplace: "",
              inputTexts: ['英文字母', '数字'],
              modelValue: _unref(formData).transactorCardCode,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).transactorCardCode) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "手机号",
          prop: "transactorPhone",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              style: {"width":"100%"},
              type: "tel",
              placeholder: "请输入",
              clearable: "",
              maxlength: 11,
              modelValue: _unref(formData).transactorPhone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).transactorPhone) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "邮箱",
          prop: "transactorEmail",
          rules: [
          {
            required: true,
            trigger: 'change',
            validator: _unref(validator).validatorEmail
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              style: {"width":"100%"},
              type: "text",
              placeholder: "请输入",
              clearable: "",
              modelValue: _unref(formData).transactorEmail,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).transactorEmail) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["rules"]),
        _createVNode(_unref(BizFormTimes), {
          class: "account-info__block",
          label: "证件有效期",
          startProp: "transactorCardStartAt",
          endProp: "transactorCardEndAt",
          start: _unref(formData).transactorCardStartAt,
          "onUpdate:start": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).transactorCardStartAt) = $event)),
          end: _unref(formData).transactorCardEndAt,
          "onUpdate:end": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).transactorCardEndAt) = $event))
        }, null, 8, ["start", "end"]),
        _createVNode(_unref(BaseFormItem), {
          style: {"grid-column-start":"1","grid-column-end":"3"},
          label: "身份证照片（人像面）",
          prop: "transactorCardZheng",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请上传'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseUpload), {
              style: {"width":"100%"},
              ref: "transactorCardZhengRef",
              listType: "picture-card",
              disabled: _unref(disabled),
              accept: ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'],
              drag: false,
              limit: 1,
              limitSize: 5,
              multiple: false,
              "auto-upload": true,
              onError: _unref(onUploadErr),
              "http-request": _unref(uploadApi),
              beforeRemove: 
            (file, remove) => {
              remove();
              _unref(onUploadRemove)('transactorCardZheng');
              return true;
            }
          ,
              fileList: _unref(uploadModelMap).transactorCardZheng,
              "onUpdate:fileList": _cache[6] || (_cache[6] = ($event: any) => ((_unref(uploadModelMap).transactorCardZheng) = $event)),
              onChange: _cache[7] || (_cache[7] = v => _unref(onUploadChange)(v, 'transactorCardZheng'))
            }, {
              tip: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["disabled", "onError", "http-request", "beforeRemove", "fileList"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          style: {"grid-column-start":"3","grid-column-end":"5"},
          label: "身份证照片（国徽面）",
          prop: "transactorCardFan",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请上传'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseUpload), {
              style: {"width":"100%"},
              ref: "transactorCardFanRef",
              listType: "picture-card",
              disabled: _unref(disabled),
              accept: ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'],
              drag: false,
              limit: 1,
              limitSize: 5,
              multiple: false,
              "auto-upload": true,
              onError: _unref(onUploadErr),
              "http-request": _unref(uploadApi),
              beforeRemove: 
            (file, remove) => {
              remove();
              _unref(onUploadRemove)('transactorCardFan');
              return true;
            }
          ,
              fileList: _unref(uploadModelMap).transactorCardFan,
              "onUpdate:fileList": _cache[8] || (_cache[8] = ($event: any) => ((_unref(uploadModelMap).transactorCardFan) = $event)),
              onChange: _cache[9] || (_cache[9] = v => _unref(onUploadChange)(v, 'transactorCardFan'))
            }, {
              tip: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["disabled", "onError", "http-request", "beforeRemove", "fileList"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})